import { render, staticRenderFns } from "./DashboardArea.vue?vue&type=template&id=2ff78a7a&scoped=true"
import script from "./DashboardArea.vue?vue&type=script&lang=js"
export * from "./DashboardArea.vue?vue&type=script&lang=js"
import style0 from "./DashboardArea.vue?vue&type=style&index=0&id=2ff78a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff78a7a",
  null
  
)

export default component.exports